import { ReactElement } from 'react'

import FindFavorecidosContaBancariaImpl from 'modules/pagamentos/domain/usecases/FindFavorecidosContaBancaria'
import FindFavorecidosTmovPayImpl from 'modules/pagamentos/domain/usecases/FindFavorecidosTmovPay'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import SelecionarFavorecido from 'modules/pagamentos/pages/components/Transferir/components/SelecionarFavorecido'
import ContaPagamentoContraCteImpl from '../../domain/usecases/ContaPagamentoContraCte'

export const SelecionarFavorecidoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const findFavorecidosTmovPay = new FindFavorecidosTmovPayImpl(
    pagamentoRepository,
  )
  const findFavorecidosContaBancaria = new FindFavorecidosContaBancariaImpl(
    pagamentoRepository,
  )
  const contaPagamentoContraCte = new ContaPagamentoContraCteImpl(
    pagamentoRepository,
  )

  return (
    <SelecionarFavorecido
      findFavorecidosTmovPay={findFavorecidosTmovPay}
      findFavorecidosContaBancaria={findFavorecidosContaBancaria}
      contaPagamentoContraCte={contaPagamentoContraCte}
    />
  )
}
